import React, { useMemo } from 'react'
import { createSelector } from 'reselect'
import { maxBy } from 'lodash'

import { useSelector } from 'react-redux'
import { getAssets } from '~/selectors'
import { useChanged, useRefWithSetter, useBoundingRect } from '~/hooks'
import { time2Pixel } from '~/Util'

// ---

export const Context = React.createContext({
  maxLayerWidth: 0,
  timelineWidth: 0,
  timelineHeight: 0,
})

// ---

const getMaxLayerTime = createSelector(
  [ getAssets, state => state.timeline.sliderTime ],
  (assets, sliderTime) => {
    if (assets.length === 0) {
      return sliderTime || 0
    }
    const { endTime = 0 } = maxBy(assets, x => x.endTime) || {}
    return Math.max(sliderTime, endTime)
  }
)

export default function TimelineGeometryContextProvider({ children }) {
  const maxLayerTime = useSelector(getMaxLayerTime)
  const scale = useSelector(state => state.timeline.scale)
  const [ ref, setRef ] = useRefWithSetter()
  const options = useMemo(() => ({ throttle: 20 }), [])
  const rect = useBoundingRect(ref, options)

  const context = useChanged({
    maxLayerWidth: time2Pixel(maxLayerTime, scale),
    timelineWidth: rect.width,
    timelineHeight: rect.height,
  })

  return (
    <Context.Provider value={context}>
      {children(setRef)}
    </Context.Provider>
  )
}
